import { useContext } from 'react'
import ProceduresManagementContext from '../../contexts/ProceduresManagementContext'

export const useProceduresManagement = () =>
	useContext(ProceduresManagementContext)
